export default {"src":"/_next/static/media/office-icon.545d79ee.svg","height":96,"width":59,"blurWidth":0,"blurHeight":0};